import RoomPlayerInstance from "./RoomPlayerInstance";
import { STATUS, ACTIONS } from "../../../../Models/ENUM";
import ARRAY from "../../../../UTIL/ARRAY";

class RoomPlayerStatus
{
    private Player : RoomPlayerInstance;

    constructor( Player:RoomPlayerInstance )
    {
        this.Player    = Player;
    }

    public playing( data?:any )
    {
        this.set( STATUS.PLAYING, data );
    }

    public ready( data?:any )
    {
        this.set( STATUS.READY, data );
    }

    public rewarded( data?:any )
    {
        this.set( STATUS.REWARDED, data );
    }

    public OVER( data?:any )
    {
        this.set( STATUS.OVER, data );
    }

    public busy( data?:any )
    {
        this.set( STATUS.BUSY, data );
    }

    public lobby( data?:any )
    {
        this.set( STATUS.LOBBY, data );
    }
 
    private set( status:number, data?:any )
    {
        if( this.Player.data.status === status ) return;
        
        this.Player.Room.doSend( ACTIONS.PLAYERSTATUS, ARRAY.extract({ status:status }, data ) );
    }

}

export default RoomPlayerStatus;